/* script */
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// Components
import Badge from 'shared/ui/components/Badge.vue';

const __vue_script__ = {
    name: 'DoubleStat',

    components: { Badge },

    props: {
        title: {
            type: String,
            required: true
        },

        statA: {
            type: [Number, String],
            required: true
        },

        labelA: {
            type: String,
            required: true
        },

        statB: {
            type: [Number, String],
            default: null
        },

        labelB: {
            type: String,
            default: null
        },

        sub: {
            type: String,
            default: null
        },

        color: {
            type: String,
            default: null
        },

        badgeClass: {
            type: String,
            default: null
        },

        footerStats: {
            type: Array,
            default: () => [],
        },
    },

    data() {
        return {
            style: this.color ? { 'border-top-color': this.color } : null,
        };
    },

    computed: {
        hasStatB() {
            return Number.isFinite(this.statB);
        },

        /** @returns {{ label: string, stat: string|number }[]} */
        footerData() {
            return (this.footerStats || [])
                .filter(d => this.isStringOrNumber(d.label) && this.isStringOrNumber(d.stat));
        },

        showFooter() {
            return Boolean(this.footerData.length);
        }
    },

    methods: {
        /**
         * @param {unknown} d
         * @returns {boolean}
         */
        isStringOrNumber(d) {
            return ['string', 'number'].includes(typeof d);
        }
    }
};

/* template */
var __vue_render__ = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"double-stat card",style:(_vm.style)},[_c('div',{staticClass:"name"},[_vm._v(_vm._s(_vm.title))]),(_vm.sub)?_c('div',{staticClass:"sub"},[_vm._v(_vm._s(_vm.sub))]):_vm._e(),_c('div',{staticClass:"stats"},[_c('div',{staticClass:"stat-a"},[_c('div',{staticClass:"count"},[_vm._v(_vm._s(_vm.statA))]),_c('div',{staticClass:"label"},[_vm._v(_vm._s(_vm.labelA))])]),(_vm.hasStatB)?_c('div',{staticClass:"stat-b"},[_c('div',{staticClass:"count"},[_vm._v(_vm._s(_vm.statB))]),_c('div',{staticClass:"label"},[_vm._v(_vm._s(_vm.labelB))])]):_vm._e()]),(_vm.showFooter)?_c('div',{staticClass:"footer"},[_c('div',{staticClass:"footer-content"},_vm._l((_vm.footerData),function(d){return _c('div',[_c('badge',{staticClass:"count",class:_vm.badgeClass},[_vm._v(_vm._s(d.stat))]),_c('span',{staticClass:"label"},[_vm._v(_vm._s(d.label))])],1)}),0)]):_vm._e()])}
var __vue_staticRenderFns__ = []

  /* style */
  const __vue_inject_styles__ = undefined
  /* scoped */
  const __vue_scope_id__ = undefined
  /* module identifier */
  const __vue_module_identifier__ = undefined
  /* functional template */
  const __vue_is_functional_template__ = false
  /* component normalizer */
  function __vue_normalize__(
    template, style, script,
    scope, functional, moduleIdentifier, shadowMode,
    createInjector, createInjectorSSR, createInjectorShadow
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {}

    // For security concerns, we use only base name in production mode.
    component.__file = "DoubleStat.vue"

    if (!component.render) {
      component.render = template.render
      component.staticRenderFns = template.staticRenderFns
      component._compiled = true

      if (functional) component.functional = true
    }

    component._scopeId = scope

    if (false) {
      let hook
      if (false) {
        // In SSR.
        hook = function(context) {
          // 2.3 injection
          context =
            context || // cached call
            (this.$vnode && this.$vnode.ssrContext) || // stateful
            (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__
          }
          // inject component styles
          if (style) {
            style.call(this, createInjectorSSR(context))
          }
          // register component module identifier for async chunk inference
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier)
          }
        }
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        component._ssrRegister = hook
      }
      else if (style) {
        hook = shadowMode 
          ? function(context) {
              style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot))
            }
          : function(context) {
              style.call(this, createInjector(context))
            }
      }

      if (hook !== undefined) {
        if (component.functional) {
          // register for functional component in vue file
          const originalRender = component.render
          component.render = function renderWithStyleInjection(h, context) {
            hook.call(context)
            return originalRender(h, context)
          }
        } else {
          // inject component registration as beforeCreate hook
          const existing = component.beforeCreate
          component.beforeCreate = existing ? [].concat(existing, hook) : [hook]
        }
      }
    }

    return component
  }
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  )

  export default __vue_component__